//1 = light blue, 2 = blue, 3 = yellow, 4 = red

export const bowstaff = [
    0, 0, 0, 4, 2, 2, 2, 5, 0, 0, 0, 0, 
    0, 0, 0, 3, 0, 0, 5, 2, 0, 4, 4, 0, 
    0, 0, 0, 0, 3, 0, 0, 4, 1, 1, 4, 0, 
    0, 0, 0, 0, 0, 3, 0, 4, 1, 1, 0, 0, 
    0, 0, 0, 0, 0, 0, 3, 2, 4, 4, 2, 5, 
    0, 0, 0, 0, 0, 0, 2, 3, 0, 0, 5, 2, 
    0, 0, 0, 0, 0, 2, 0, 0, 3, 0, 0, 2, 
    0, 0, 0, 0, 2, 0, 0, 0, 0, 3, 0, 2, 
    0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 3, 4, 
    0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 
    1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 
    1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
]